"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalNetInfoSchema = void 0;
const zod_1 = require("zod");
const metadata_1 = require("./metadata");
exports.GlobalNetInfoSchema = zod_1.z.object({
    name: zod_1.z.string(),
    metadata: metadata_1.MetadataSchema.optional(),
});
//# sourceMappingURL=GlobalNetInfo.js.map